import axios from 'axios';
const GUID_LINK_PATH_PATH = '/api/guid-link';
const GUID_LINK_PATH_LOOKUPS_PATH = '/api/guid-link/lookups';
const SUBMIT_ENDING = '/submit';
const PAYMENT_LINK_ENDING = '/payment-link';
class GuidLinkService {
  async fetchEstimateLink(params) {
    const url = `${GUID_LINK_PATH_PATH}/${params}/`;
    const response = axios.get(url);
    return response;
  }
  async fetchServiceOrder(params) {
    const url = `${GUID_LINK_PATH_PATH}/${params}/service-order`;
    const response = axios.get(url);
    return response;
  }
  async fetchPartsOrder(params) {
    const url = `${GUID_LINK_PATH_PATH}/${params}/parts-order`;
    const response = axios.get(url);
    return response;
  }
  async fetchEstimateLinkLookups() {
    const url = `${GUID_LINK_PATH_LOOKUPS_PATH}`;
    const response = axios.get(url);
    return response;
  }
  async submitEstimateLink(params) {
    const url = `${GUID_LINK_PATH_PATH}/${SUBMIT_ENDING}`;
    const response = await axios.post(url, params);
    return response;
  }
  async fetchUnit(unitId) {
    const url = `${GUID_LINK_PATH_PATH}/unit/${encodeURIComponent(unitId)}`;
    const unitResponse = await axios.get(url);
    return unitResponse;
  }
  async getPaymentLink(guid) {
    const url = `${GUID_LINK_PATH_PATH}/${encodeURIComponent(guid)}${PAYMENT_LINK_ENDING}`;
    const response = await axios.get(url);
    return response;
  }
}
export default new GuidLinkService(); // singleton object
